import React from "react";
import ReviewSectionWithProduct from "../components/Shared/ReviewSectionWithProduct";
import FaqAndContactSection from "../components/Shared/FaqAndContactSection";
import { appstoreicon, googleplayicon } from "../assets";
import { Link } from "react-router-dom";

const reviews = [
  {
    href: "https://www.trustpilot.com/reviews/dummy1",
    rating: 5,
    date: "November 1, 2024",
    review: "Great quality, exceeded expectations!",
    product: {
      name: "Dummy Watch 1",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 28, 2024",
    shippedFrom: "Country X",
    reviewer: {
      name: "John Doe",
      location: "Country X",
      initial: "JD",
      color: "blue",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy2",
    rating: 4,
    date: "November 2, 2024",
    review: "The product was good, but the delivery was delayed.",
    product: {
      name: "Dummy Watch 2",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 29, 2024",
    shippedFrom: "Country Y",
    reviewer: {
      name: "Jane Smith",
      location: "Country Y",
      initial: "JS",
      color: "red",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy3",
    rating: 3,
    date: "November 3, 2024",
    review: "The watch was fine, but customer support was not responsive.",
    product: {
      name: "Dummy Watch 3",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 30, 2024",
    shippedFrom: "Country Z",
    reviewer: {
      name: "Alex Johnson",
      location: "Country Z",
      initial: "AJ",
      color: "purple",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy4",
    rating: 5,
    date: "November 4, 2024",
    review: "Amazing watch, and the service was top-notch.",
    product: {
      name: "Dummy Watch 4",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 31, 2024",
    shippedFrom: "Country W",
    reviewer: {
      name: "Emily White",
      location: "Country W",
      initial: "EW",
      color: "orange",
    },
  },
];
const faqs = [
  {
    id: 224,
    question: "What is the Watch Collection?",
    answer:
      "The Watch Collection lets you manage and track all of your watches online. Simply enter each watch's details and, if you'd like, add your own photos. You'll then have access to historical price trends, as well as projections of your timepieces' future financial performance. You can also use the Watch Collection to follow other watches you are interested in.",
  },
  {
    id: 225,
    question: "Do I have to own a watch to add it to my Watch Collection?",
    answer:
      "No, you can also follow watches that you are simply interested in. To track a watch's performance, enter its reference number or brand, model, and condition and select the option 'I don't own this watch.'",
  },
  {
    id: 226,
    question: "How many watches can I add to my Watch Collection?",
    answer: "You may add an unlimited number of watches.",
  },
  {
    id: 227,
    question:
      "Why is there a watch in my Watch Collection that I didn't personally add?",
    answer:
      "As soon as you purchase a watch on WristLink, it is automatically added to your Watch Collection, allowing you to track its value over time.",
  },
  {
    id: 228,
    question: "Which estimated values are available in the Watch Collection?",
    answer:
      "You can view the estimated value and change in value of each individual watch, as well as your entire collection.",
  },
  {
    id: 229,
    question: "How often is the estimated value updated?",
    answer:
      "Estimated values are reassessed on a daily basis. However, price fluctuations are only visible across longer periods of time.",
  },
  {
    id: 231,
    question: "Can I save personal information in the Watch Collection?",
    answer: "Yes, you can add your own photos and notes to each watch.",
  },
  {
    id: 232,
    question: "Can I add rare timepieces to the Watch Collection?",
    answer:
      "Yes, you can add any watch to your Watch Collection so that it is complete. That being said, there may be little to no data available on rare watches. If the same model is added by other users and we have sufficient data, new information will be added to your Watch Collection automatically.",
  },
  {
    id: 350,
    question: "Why are Rolex watches so expensive?",
    answer:
      "It's very difficult to buy a Rolex from offline retailers. At the same time, demand is extremely high, which in turn drives prices upward. Rolex is renowned for their premium quality, high precision, and innovative designs. As a result, Rolex watches enjoy tremendous prestige and are often considered status symbols. What's more, Rolex models are highly likely to increase in value, which also contributes to the brand's appeal.",
  },
];
const infoData = [
  {
    title: "All Your Watches in One Place",
    content:
      "Whether it's your own personal watch collection or just watches you want to keep an eye on, the Watch Collection brings together all your favorite pieces as you've never seen them before: online and at your fingertips – on your smartphone! Maintain your Watch Collection wherever and whenever you want, and personalize it with your own photos.",
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&", // Add the image URL here
  },
  {
    title: "Monitor Market Performance",
    content:
      "Find out the current estimated value of your watches, check how the market is doing, and keep track of your profits and losses over time.",
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&", // Add the image URL here
  },
  {
    title: "Buy & Sell at Just the Right Time",
    content:
      "Timing is everything: Use our worldwide, one-of-a-kind database to determine the best time to sell your watches or add new watches to your collection.",
    imgUrl:
      "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&", // Add the image URL here
  },
];

const WatchCollection = () => {
  return (
    <>
      <HeroSection />
      <InfoGraphicsSection data={infoData} />

      <BannerSection />

      <ReviewSectionWithProduct
        reviews={reviews}
        // sectionClassName={"bg-secondary text-white"}
        sectionClassName={"bg-[#F3F3F3] text-black"}
        navBtnStyle={{ color: "black" }}
        ctaBtnStyle={{ borderColor: "black" }}
        sectionTitle={"Over 800,000 satisfied watch buyers worldwide"}
        sectionSubTitle={
          "Wrist-Wurx dealers receive great ratings: 4.8 out of 5 "
        }
      />

      <FaqSection faqs={faqs} />
    </>
  );
};

export default WatchCollection;

const HeroSection = () => {
  const imgUrl =
    "https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&";
  return (
    <section className="bg-[#F6F2EE] min-h-[420px]">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex lg:flex-row md:flex-col-reverse sm:flex-col-reverse  items-center gap-4">
        <div className="lg:w-1/2 md:w-full sm:w-full my-auto flex flex-col lg:items-start md:items-center sm:items-center  ">
          <h3 className="lg:text-lg md:text-md sm:text-sm uppercase font-normal mb-2">
            {" "}
            Watch Collection
          </h3>
          <h1 className="lg:text-6xl md:text-4xl sm:text-3xl lg:text-left md:text-center sm:text-center font-medium mb-8">
            Start Your Own Online Watch Collection{" "}
          </h1>
          {/* CTA */}
          <button className="w-fit px-8 py-3 rounded bg-black text-white font-semibold">
            {" "}
            Get started
          </button>
        </div>
        <div className="lg:w-1/2 md:w-full sm:w-full">
          <div
            style={{ backgroundImage: `url(${imgUrl})` }}
            className="ml-auto lg:w-11/12 md:w-full sm:w-full rounded-lg lg:min-h-[320px] md:min-h-[300px] sm:min-h-[200px] bg-center bg-cover bg-no-repeat"
          />
        </div>
      </div>
    </section>
  );
};

const InfoGraphicsSection = ({ data }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex flex-col gap-12">
      {data?.map((infoSection, index) => {
        return (
          <div
            key={index}
            className={`w-full flex  items-center lg:gap-12 md:gap-6 sm:gap-6 ${
              index % 2 === 1
                ? "lg:flex-row md:flex-col-reverse sm:flex-col-reverse"
                : "lg:flex-row-reverse md:flex-col-reverse sm:flex-col-reverse"
            }`}
          >
            <div className="lg:w-1/2 md:w-full sm:w-full my-auto">
              <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6">
                {infoSection?.title}
              </h2>
              <p className="">{infoSection?.content}</p>
            </div>
            <div
              style={{ backgroundImage: `url(${infoSection?.imgUrl})` }}
              className="lg:w-1/2 md:w-full sm:w-full rounded-lg lg:min-h-[348px] md:min-h-[300px] sm:min-h-[200px] bg-center bg-cover bg-no-repeat"
            />
          </div>
        );
      })}

      {/* CTA */}
      <button className="mx-auto w-fit px-8 py-3 rounded bg-black text-white font-semibold">
        {" "}
        Start your collection
      </button>
    </section>
  );
};

const BannerSection = () => {
  const description =
    "Download the WristLink app now and add models to your Watch Collection using the Watch Scanner. Whether it's on your wrist, in a magazine article, or in a display case, all it takes is a single photo to add a new watch to your online collection.";
  const imgUrl =
    "https://cdn.discordapp.com/attachments/920721313105080390/1305576703753457689/Frame_17.png?ex=6733888e&is=6732370e&hm=ea50026ec2348520e21cbd702a4295476de91fb5f75b85b2290db903dc68ffe0&";
  return (
    <section className="lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12">
      <div className="max-w-[1200px] min-h-[470px] mx-auto  bg-secondary text-white rounded-lg  grid lg:grid-cols-2 sm:grid-cols-1">
        {/* BANNER IMAGE FOR SMALL DEVICE */}
        <div
          className="rounded-t-lg lg:hidden md:block sm:block min-h-[360px]"
          style={{
            backgroundImage: `url(${imgUrl})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        />

        {/* BANNER CONTENT  */}
        <div className="lg:p-12 md:p-8 sm:p-6 flex flex-col justify-between">
          {/* BANNER MESSAGE */}
          <div className="my-auto">
            <h3 className="lg:text-2xl md:text-xl sm:text-lg font-medium ">
              Watch Scanner
            </h3>
            <h2 className="lg:text-3xl md:text-2xl sm:text-xl font-semibold mb-6">
              Build Your Collection With Photos
            </h2>

            <div className="mb-6">
              <span className="">{description}</span>
            </div>
          </div>
          {/* CTA */}
          <div className="">
            <span className="lg:text-[14px] md:text-[12px] sm:text-[10px]">
              {" "}
              Install the app to try it now:
            </span>
            <div className="flex gap-2 mt-2">
              <Link
                className="block mb-2"
                to="https://discover.chrono24.com/VuxF?af_xp=custom&pid=WristLink&c=footer&af_dp=WristLink-app://&utm_source=WristLink&utm_medium=onsite&utm_campaign=footer"
                target="_blank"
                aria-label="To the App Store"
              >
                <img
                  src={appstoreicon}
                  alt="App Store"
                  className="h-[40px] w-[135px]"
                />
              </Link>
              <Link
                to="https://discover.chrono24.com/VuxF?af_web_dp=https://play.google.com/store/apps/details?id=com.WristLink.mobile&af_xp=custom&pid=WristLink&c=footer&af_dp=WristLink-app://&utm_source=WristLink&utm_medium=onsite&utm_campaign=footer"
                target="_blank"
                aria-label="To Google Play"
              >
                <img
                  src={googleplayicon}
                  alt="Google Play"
                  className="h-[40px] w-[135px]"
                />
              </Link>
            </div>
          </div>
        </div>

        {/* BANNER IMAGE FOR LARGE DEVICE */}
        <div
          className="rounded-r-lg lg:block md:hidden sm:hidden min-h-[360px]"
          style={{
            backgroundImage: `url(${imgUrl})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        />
      </div>
    </section>
  );
};

const FaqSection = ({ faqs }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
      <FaqAndContactSection faqs={faqs} />
    </section>
  );
};
